export default __webpack_public_path__ + "static/want_sub-206505dfb151eba9ae115d33729e0296.png";